
import $tm_message_box from '@/components/common/MessageBox.js';
import store from '@/store';


/* 过滤器s */
import dayjs from 'dayjs';
export const filters = {
    /*权限校验*/
    pagePermission(rightKey) {
      const permissions = store.getters.pagePerms;
      return rightKey ? permissions.indexOf(rightKey) > -1 || permissions.indexOf('all') > -1 : true;
    },
    /*时间格式化*/
    dateTimeFormat (time, fmt) {
        return time ? dayjs(new Date(time)).format(fmt ? fmt : 'YYYY-MM-DD HH:mm:ss') : '';
    },
    /* 列表序号 */
    tableIndex (index, pageNo, pageSize) {
        return index + (pageNo - 1) * pageSize + 1;
    },
    removeHtml: function (str) {
        var reg = /<\s*\/?\s*[^>]*\s*>/gi;
        return str.replace(reg, '');
    },
};

/**
 * 树节点转换为一维数组
 * @param {*} treeData 
 * @param {*} subKeyName 
 * @returns 
 */
export const flattenTreeData = (treeData, subKeyName = 'children') => {
  let list = [];
  treeData.forEach((v, i) => {
    v.index = i;
    list.push(v);
    if (v[subKeyName] && !!v[subKeyName].length) {
      list = list.concat(flattenTreeData(v[subKeyName]));
    }
  })
  return list;
};

/**
 * @description: 根据dom属性获取dom对象
 * @param {*} dom 要查询的根结点
 * @param {*} tags 标签
 * @param {*} attribute 属性名
 * @param {*} attributeValue 属性值
 * @return {*}
 */
export function getElementsByAttribute (dom, tags, attribute, attributeValue) {
    let arr = [];
    tags.map((n) => {
        let doms = dom.getElementsByTagName(n);
        for (let i = 0; i < doms.length; i++) {
            if (doms[i].getAttribute(attribute) == attributeValue) {
                arr.push(doms[i]);
            }
        }
    });
    return arr;
}

// 复制内容到粘贴板
export function copy_value (val) {
  const copyInput = document.createElement('input')
  document.body.appendChild(copyInput)
  copyInput.setAttribute('value', val)
  copyInput.select()
  document.execCommand('Copy')
    $tm_message_box.toast('内容已复制到粘贴板', { type: 'success' });
  // $tm_message_box.alert('复制成功', '', {type: 'success'})
  copyInput.remove()
}

/**
 * 文件大小格式化
 * @param {number} size b为单位
 * @returns
 */
export const fileSizeFormat = (bytes, decimals) => {
    if (!bytes) return '-';
    if (bytes == 0) return '0 B';
    var k = 1024,
        dm = decimals <= 0 ? 0 : decimals || 2,
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/**
 * 秒转换为时分秒
 * @param {number} duration s为单位的时长
 * @returns
 */
export const durationFormat = (duration) => {
    let h = parseInt((duration / 60 / 60) % 24);
    let m = parseInt((duration / 60) % 60);
    let s = parseInt(duration % 60);

    h = h < 10 ? '0' + h : h || '';
    m = m < 10 ? '0' + m : m || '';
    s = s < 10 ? '0' + s : s || '';

    return `${h}:${m}:${s}`;
};


/**
 * 从地址栏获取指定参数值
 * @param {*string} param
 */
export const getUrlParam = (name, url) => {
    const search = url ? url.split('?')[1] : location.search; // 返回类似于 ?a=10&b=20&c=30
    const res = new URLSearchParams(search);
    return res.get(name);
};

/**
 * @description: 获取对象的任意层级
 * @param {*} obj
 * @param {*} keyStr
 * @return {*}
 */
export const getProperty = (obj, keyStr) => {
    keyStr = keyStr.replace(/\[(\w+)\]/g, '.$1');
    let keyArray = keyStr.split('.');
    for (let i in keyArray) {
        obj = obj[keyArray[i]] || null;
    }
    return obj;
};

// 判断是IOS还是Android
export const mobileType = () => {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return { isAndroid, isiOS }
}

// input只能输入数字和小数
export const formatDecimalNum = (obj) => {
  if (obj !== '' && obj.substr(0, 1) === '.') {
    obj = '';
  }
  obj = obj.replace(/^0*(0\.|[1-9])/, '$1'); // 粘贴不生效
  obj = obj.replace(/[^\d.]/g, ''); // 清除“数字”和“. -”以外的字符
  obj = obj.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
  obj = obj.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
  // obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
  if (obj.indexOf('.') < 0 && obj !== '') {
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的数
    if (obj.substr(0, 1) === '0' && obj.length === 2) {
      obj = obj.substr(1, obj.length);
    }
  }
  return obj;
};


export const formatDatetime = function (date, fmt = "yyyy-MM-dd HH:mm:ss") {
  if (!date) return "";
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "H+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length));
    }
  }
  return fmt;
}


export const beginOfWeek = (dateValue) => {
  let date;
  if (dateValue instanceof Date) {
    date = dateValue;
  } else {
    date = new Date(dateValue);
  }
  let subDay = 0;
  let weekDay = date.getDay();
  if (weekDay == 0) {
    //周天
    subDay = 6;
  } else {
    subDay = weekDay - 1
  }
  let beginDateTime = date.getTime() - (86400000 * subDay);
  return new Date(beginDateTime);
}
export const endOfWeek = (dateValue) => {
  let date;
  if (dateValue instanceof Date) {
    date = dateValue;
  } else {
    date = new Date(dateValue);
  }
  let weekDay = date.getDay();
  if (weekDay == 0) {
    //周天
    return date;
  } else {
    let addDay = 7 - weekDay;
    let endDateTime = date.getTime() + (86400000 * addDay);
    return new Date(endDateTime);
  }
}

// 获取上个月
export const getPreMonth = (date = new Date()) => {
  let newDate = '';
  const month = date.getMonth();
  const year = date.getFullYear();
  const d = date.getDate();
  if (d === 1) {
    if (month === 0) {
      newDate = new Date(year-1, 11);
    } else {
      newDate = new Date(year, month - 1);
    }
  } else {
    newDate = new Date();
  }
  
  return newDate;
}

export const numberToChinese = (num) => {
  var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
  var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿');//可继续追加更高位转换值
  if (!num || isNaN(num)) {
    return "零";
  }
  var english = num.toString().split("");
  var result = "";
  for (var i = 0; i < english.length; i++) {
    var des_i = english.length - 1 - i;//倒序排列设值
    result = arr2[i] + result;
    var arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  //将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
  //合并中间多个零为一个零
  result = result.replace(/零+/g, '零');
  //将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
  //将【亿万】换成【亿】
  result = result.replace(/亿万/g, '亿');
  //移除末尾的零
  result = result.replace(/零+$/, '');
  //将【零一十】换成【零十】
  //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
  //将【一十】换成【十】
  result = result.replace(/^一十/g, '十');
  return result;
}